export default __webpack_public_path__ + "static/media/hildinganderslogo-black.32261700.png";